import { useEffect, useState } from 'react';

import { applyPhoneFlag, isPhone } from './detect';
import { maybeRedirectPrematch } from './prematch';
import { lastFrameStale } from './stale';
import { registerPhoneSw } from './sw';
import { bootTelegram } from './telegram';
import { bindViewport, unbindViewport } from './viewport';
import { usePhone } from './usePhone';
import { PhoneQueueBar } from './PhoneQueue';
import './phone.css';

/**
 * Только телефон: флаг, клавиатура, SW, Mini App, старт прематча.
 * Сокет и BB не трогаем — Screen уже держит кадр на pagehide.
 */
export function PhoneBoot(): React.ReactElement | null {
  const phone = usePhone();
  const [stale, setStale] = useState(false);

  useEffect(() => {
    applyPhoneFlag();
    if (!isPhone()) return;
    bindViewport();
    registerPhoneSw();
    bootTelegram();
    maybeRedirectPrematch();
    setStale(lastFrameStale());
    return () => unbindViewport();
  }, [phone]);

  if (!phone) return null;
  return (
    <>
      {stale && (
        <p className="ph-seat" role="status">
          кадр протух. это не живая лента — дождитесь эфира.
        </p>
      )}
      <PhoneQueueBar />
    </>
  );
}
